var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery2 = function SvgBattery2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Battery Accumulator"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 8,
    y: 16,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.89 10.55A.98.98 0 0 0 39 10H25a.98.98 0 0 0-.89.55L22.39 14h19.23ZM19 10a1.003 1.003 0 0 0-1-1H8a1.003 1.003 0 0 0-1 1v4h12ZM17 5a1.003 1.003 0 0 0-1-1h-6a1.003 1.003 0 0 0-1 1v2h8ZM55 5a1.003 1.003 0 0 0-1-1h-6a1.003 1.003 0 0 0-1 1v2h8ZM57 10a1.003 1.003 0 0 0-1-1H46a1.003 1.003 0 0 0-1 1v4h12ZM4 59a1.003 1.003 0 0 0 1 1h54a1.003 1.003 0 0 0 1-1V26H4Zm45-28h1v-1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1h-1a1 1 0 0 1 0-2M21.27 44.32l12-13A1 1 0 0 1 35 32v8h7a.996.996 0 0 1 .73 1.68l-12 13A.99.99 0 0 1 30 55a.9.9 0 0 1-.36-.07A.99.99 0 0 1 29 54v-8h-7a.996.996 0 0 1-.73-1.68M11 31h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 45v6.44L39.72 42H34a1.003 1.003 0 0 1-1-1v-6.44L24.28 44H30a1.003 1.003 0 0 1 1 1"
  }))));
};
export default SvgBattery2;